import { render, staticRenderFns } from "./getpwdsubmit.vue?vue&type=template&id=61afe856&"
import script from "./getpwdsubmit.vue?vue&type=script&lang=js&"
export * from "./getpwdsubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports